var map = {
	"./clubs_10.svg": 7283,
	"./clubs_2.svg": 3586,
	"./clubs_3.svg": 6227,
	"./clubs_4.svg": 2188,
	"./clubs_5.svg": 1901,
	"./clubs_6.svg": 2782,
	"./clubs_7.svg": 3887,
	"./clubs_8.svg": 1000,
	"./clubs_9.svg": 5865,
	"./clubs_ace.svg": 3181,
	"./clubs_jack.svg": 1121,
	"./clubs_king.svg": 3677,
	"./clubs_queen.svg": 8742,
	"./diamonds_10.svg": 4879,
	"./diamonds_2.svg": 9318,
	"./diamonds_3.svg": 6439,
	"./diamonds_4.svg": 2984,
	"./diamonds_5.svg": 905,
	"./diamonds_6.svg": 154,
	"./diamonds_7.svg": 4347,
	"./diamonds_8.svg": 6732,
	"./diamonds_9.svg": 7357,
	"./diamonds_ace.svg": 2281,
	"./diamonds_jack.svg": 5933,
	"./diamonds_king.svg": 9942,
	"./diamonds_queen.svg": 5578,
	"./hearts_10.svg": 2299,
	"./hearts_2.svg": 8362,
	"./hearts_3.svg": 7419,
	"./hearts_4.svg": 5268,
	"./hearts_5.svg": 9989,
	"./hearts_6.svg": 854,
	"./hearts_7.svg": 8391,
	"./hearts_8.svg": 2912,
	"./hearts_9.svg": 5713,
	"./hearts_ace.svg": 7301,
	"./hearts_jack.svg": 5769,
	"./hearts_king.svg": 2469,
	"./hearts_queen.svg": 830,
	"./joker_black.svg": 5299,
	"./joker_red.svg": 4303,
	"./spades_10.svg": 8324,
	"./spades_2.svg": 8543,
	"./spades_3.svg": 3902,
	"./spades_4.svg": 5457,
	"./spades_5.svg": 7424,
	"./spades_6.svg": 2083,
	"./spades_7.svg": 8354,
	"./spades_8.svg": 6053,
	"./spades_9.svg": 8804,
	"./spades_ace.svg": 9688,
	"./spades_jack.svg": 1238,
	"./spades_king.svg": 8322,
	"./spades_queen.svg": 4659
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87;